import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import MenuView from 'jet-views/menu'; // Import MenuView component
import ToolView from 'jet-views/toolbar'; // Import ToolView component
import { devConfig } from 'config/config'; // Import development configuration

/**
 * Class representing the configuration agent list view.
 * @extends JetView
 */
export default class configurationAgentListView extends JetView {
    /**
     * Defines the layout configuration for the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Get localization service
        return {
            type: 'wide', // Set layout type
            cols: [
                {
                    localId: 'inner:layout', // Local ID for the inner layout
                    type: 'wide', // Set inner layout type
                    rows: [
                        {
                            view: 'tabbar', // Create a tab bar
                            localId: 'tabbar', // Local ID for the tab bar
                            height: 43, // Set height of the tab bar
                            options: [
                                // Define tab options
                                {
                                    id: 'security.adminuser.configuration.changePassword', // Tab ID
                                    value: _('Cambiar Contraseña'), // Tab label
                                    hidden: !devConfig.getPermAction(
                                        // Determine visibility based on permissions
                                        'AdminuserConfigurationChangePasswordMenu',
                                        'Menu',
                                    ),
                                    css: 'prm-AdminuserConfigurationChangePasswordMenu', // CSS class for styling
                                },
                                {
                                    id: 'security.adminuser.configuration.generateToken', // Tab ID
                                    value: _('Generar Token'), // Tab label
                                    hidden: !devConfig.getPermAction(
                                        // Determine visibility based on permissions
                                        'AdminuserConfigurationGenerateTokenMenu',
                                        'Menu',
                                    ),
                                    css: 'prm-AdminuserConfigurationGenerateTokenMenu', // CSS class for styling
                                },
                                {
                                    id: 'security.adminuser.configuration.securityChanges', // Tab ID
                                    value: _('Seguridad Cambios'), // Tab label
                                    hidden: !devConfig.getPermAction(
                                        // Determine visibility based on permissions
                                        'AdminuserConfigurationSecurityChangesMenu',
                                        'Menu',
                                    ),
                                    css: 'prm-AdminuserConfigurationSecurityChangesMenu', // CSS class for styling
                                },
                                {
                                    id: 'security.adminuser.configuration.qrgoogle', // Tab ID
                                    value: _('QR Google'), // Tab label
                                    hidden: !devConfig.getPermAction(
                                        // Determine visibility based on permissions
                                        'AdminuserConfigurationQrgoogleMenu',
                                        'Menu',
                                    ),
                                    css: 'prm-AdminuserConfigurationQrgoogleMenu', // CSS class for styling
                                },
                            ],
                        },
                        { $subview: true }, // Placeholder for subviews
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use menu plugin with the tab bar
        this.on(
            this.app,
            'person:select',
            (
                person, // Listen for person selection event
            ) => this.setParam('user', person.id, true), // Set user parameter based on selected person
        );
    }
}

// FILE DOCUMENTED
